import { IUseGraphqlQueryOptions } from '@proscom/prostore-apollo-react';
import { skipIfNull } from '@proscom/prostore';
import { useAuthGraphqlQuery } from '../../../common/hooks/utils/useAuthGraphqlQuery';
import { PollType } from '../../types';
import { QUERY_GET_POLL } from '../../queries/polls';

export interface UsePollVars {
  id: string;
}

const queryOptions: IUseGraphqlQueryOptions<
  UsePollVars | null,
  PollType | null
> = {
  query: QUERY_GET_POLL,
  mapData: (result) => result.poll,
  skipQuery: skipIfNull(null)
};

export function usePoll(id?: string) {
  return useAuthGraphqlQuery({
    queryOptions,
    variables: id ? { id } : null
  });
}
